import React, { useState, useEffect } from "react";
import SideBar from "./SideBar";
import Header from "./Header";
import { SlHome } from "react-icons/sl";
import { SlArrowRight } from "react-icons/sl";
import { useLocation } from 'react-router-dom';
import { FaEdit } from "react-icons/fa";
import { FaMinusCircle } from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";
import { getCategorySubMenusAPI, cloneCategoryPriceAPI, deleteCloneCategoryPriceAPI } from '../../serverApi/server'
import { FaRegCopy } from "react-icons/fa6";


const ClonePricing = () => {
  const location = useLocation();
  const headerMenus = location.state || [];
  const subHeaderMenus = location.state || [];
  const [prices, setPrices] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(null);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedSourceMap, setSelectedSourceMap] = useState({});
  const [targetCategoryMap, setTargetCategoryMap] = useState({}); 
  const [subMenuCategoryMap, setSubMenuCategoryMap] = useState({});
  const [clonePricingState, setClonePricingState] = useState({});
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const [selectedCategory, setSelectedCategory] = useState(
    headerMenus.find((menu) => menu.additional_name === 'memorial_funeral')?.id || ''
  );
  
  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  const fetchCategorySubMenus = async () => {
    try {
      const getCategorySubMenusAPIResponse = await getCategorySubMenusAPI(selectedCategory);
      setCategoryList(getCategorySubMenusAPIResponse.data.categories_serializer)
    } catch (error) {
      console.error('Error fetching sub-menus:', error);
    }
  };

  useEffect(() => {
    if (selectedCategory) {
      fetchCategorySubMenus();
    }
  }, [selectedCategory]);

  const toggleForm = () => setFormOpen(!formOpen);
  const [formOpen, setFormOpen] = useState(false);

  const handleTargetCategoryChange = async (categoryId, selectedValue) => {
    setTargetCategoryMap((prev) => ({
      ...prev,
      [categoryId]: selectedValue,
    }));
    try {
      const res = await getCategorySubMenusAPI(selectedValue);
      const fetchedList = res.data.categories_serializer || [];
      setCategoryList((prevList) =>
        prevList.map((item) =>
          item.id === categoryId ? { ...item, source_id: fetchedList[0].id, source_category: fetchedList[0].category } : item
        )
      );
      setSubMenuCategoryMap((prev) => ({
        ...prev,
        [categoryId]: fetchedList,
      }));
    } catch (error) {
      console.error("Error fetching sub-menus:", error);
    }
  };

  const handleSourceCategoryChange = (categoryId, selectedValue) => {
    const selectedCategory = subMenuCategoryMap[categoryId]?.find(
      (cat) => String(cat.id) === String(selectedValue)
    );

    setCategoryList((prevList) =>
      prevList.map((item) =>
        item.id === categoryId ? { ...item, source_id: selectedValue, source_category: selectedCategory.category } : item
      )
    );
    setSelectedSourceMap((prev) => ({
      ...prev,
      [categoryId]: selectedValue,
    }));
  };

  const showClonePricingPopUpPage = async (selectedCategoryPrice) => {
    await setClonePricingState(selectedCategoryPrice);
    if (selectedCategoryPrice.source_id) {
      toggleForm();
      return;
    }
  };

  const saveCategoryClonePricing = async () => {
    setLoading(true);
    const cloneCategoryPriceAPIResponse = await cloneCategoryPriceAPI(clonePricingState.source_id, clonePricingState.id)
    if (cloneCategoryPriceAPIResponse.data && cloneCategoryPriceAPIResponse.data.client_status_code === 200) {
      setLoading(false);
      toggleForm();
      setToastMessage('Target category price updated successfully.');
      setToastVisible(true);
      setTimeout(()=>{
        setToastVisible(false);
      }, 2000)
      fetchCategorySubMenus();
    } else {
      setLoading(false);
      toggleForm();
      setToastMessage('Something went wrong.');
      setToastVisible(true);
      setTimeout(()=>{
        setToastVisible(false);
      }, 2000)
    }
  };

  const handleDelete = async (category) => {
    if (category.clone_status === false) {
      return;
    }
    const deleteCloneCategoryPriceAPIIResponse = await deleteCloneCategoryPriceAPI(category.id)
    if (deleteCloneCategoryPriceAPIIResponse.data && deleteCloneCategoryPriceAPIIResponse.data.client_status_code === 200) {
      fetchCategorySubMenus();
      setToastMessage('Target category price deleted successfully.');
      setToastVisible(true);
      setTimeout(()=>{
        setToastVisible(false);
      }, 2000)
    }
  };

  return (
    <div className="flex w-full h-screen">
      <div className="fixed h-full custom-scroll">
        <SideBar />
      </div>
      <div className="ml-64 flex-1 overflow-y-auto">
        <Header />
        <div className="bg-[#F5F7FD] px-7 py-6">
          <div className="flex items-center justify-between">
            <div className="text-blue-950 flex items-center gap-6">
              <h1 className="pr-6 text-2xl font-medium border-r">
                Admin Users
              </h1>
              <div className="flex text-sm items-center gap-3">
                <button>
                  <SlHome />
                </button>
                <SlArrowRight />
                <button>
                  Pricing
                </button>
                <SlArrowRight />
                <button>
                  Category Pricing
                </button>
              </div>
            </div>
          </div>
          {formOpen && (
            <div
              className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
              aria-hidden="true"
            >
              <div className="bg-white rounded-xl shadow-lg w-11/12 max-w-md p-6">
                <h5 className="text-xl font-semibold text-start text-gray-800 mb-3">
                  Are you sure?
                </h5><hr />
                <p className="text-start text-gray-600 mb-6 leading-relaxed">
                  The fields, options, and pricing details will be cloned from the 
                  <span className="font-medium text-gray-800"> source category </span>
                  to the 
                  <span className="font-medium text-gray-800"> target category </span>.<br />
                  <span className="block mt-2 text-gray-700 font-semibold">
                    ({clonePricingState.source_category} → {clonePricingState.category})
                  </span>
                </p>
                <div className="flex justify-end gap-4 border-t pt-4">
                  <button
                    type="button"
                    className="bg-red-500 hover:bg-red-600 transition-colors px-5 py-2 text-white rounded-md font-medium"
                    onClick={toggleForm}
                  >
                    Close
                  </button>
                  <button
                    className="bg-blue-500 hover:bg-blue-600 transition-colors px-5 py-2 text-white rounded-md font-medium"
                    onClick={saveCategoryClonePricing}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className='bg-white mt-10 px-3 py-4 rounded-lg'>
            <div className='flex items-center gap-3 text-sm'>
              <p className='text-neutral-500'>Filter by Role:</p>
              <div className='flex items-center gap-2'>
                <select className='focus:outline-none focus:border-blue-300 border rounded px-1 py-1'
                  onChange={handleCategoryChange}
                  value={selectedCategory}
                >
                  {headerMenus.map((menu) => (
                    <option key={menu.id} value={menu.id}>
                      {menu.menu}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="overflow-x-auto table-auto">
              <table className="min-w-full bg-white mt-8" style={{ borderCollapse: 'separate', borderSpacing: '2px' }}>
                <thead>
                  <tr>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">TARGET CATEGORY</th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">SOURCE CATEGORY</th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">STATUS</th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {categoryList.map((category) => (
                    <tr key={category.id}>
                      <td className="px-4 py-2 font-normal border border-[#48ABF7]">{category.category}</td>
                      <td className="py-2 font-normal border border-[#48ABF7]">
                        <div className="flex justify-center gap-2">
                          <select
                            name="headerName"
                            className="my-1 max-w-40 rounded-md border-2 px-[6px] py-2 focus:outline-none shadow-sm"
                            value={targetCategoryMap[category.id] || ""}
                            onChange={(e) => handleTargetCategoryChange(category.id, e.target.value)}
                          >
                            <option value="">Select Header Menu</option>
                            {subHeaderMenus.map((subMenu) => (
                              <option key={subMenu.id} value={subMenu.id}>
                                {subMenu.menu}
                              </option>
                            ))}
                          </select> 
                          <select
                            className="my-1 max-w-40 rounded-md border-2 px-[6px] py-2 focus:outline-none shadow-sm"
                            value={selectedSourceMap[category.id] || ""}
                            onChange={(e) => handleSourceCategoryChange(category.id, e.target.value)}
                          >
                            {subMenuCategoryMap[category.id]?.length ? (
                              subMenuCategoryMap[category.id].map((menu) => (
                                <option key={menu.id} value={menu.id}>
                                  {menu.category}
                                </option>
                              ))
                            ) : (
                              <option value="">Select Source Category</option>
                            )}
                          </select>
                        </div>
                      </td>
                      <td className="px-4 py-2 font-normal border border-[#48ABF7] uppercase">{category.clone_status == true ? 'Updated': ''} </td>
                      <td className="px-2 py-2 border border-[#48ABF7]">
                        <div className="flex gap-2">
                          <button
                            className="bg-blue-500 text-white py-1 px-3 rounded-full flex items-center"
                            onClick={() => showClonePricingPopUpPage(category)}
                          >
                          <FaRegCopy className="mr-[1px]" />
                            Copy
                          </button>
                          <button
                            className="bg-red-500 text-white py-1 px-3 rounded-full flex items-center"
                            onClick={() => handleDelete(category)}
                          >
                            <MdDeleteOutline className="mr-[1px]" />
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
                {toastVisible && (
                  <div
                    className="fixed h-[100px] inset-0 z-50 flex items-top justify-center bg-opacity-50"
                    aria-hidden="true"
                  >
                    <div className="bg-white rounded-xl shadow-lg w-11/12 max-w-md p-6">
                      <h5 className="text-xl font-semibold text-start text-gray-800 mb-3">
                        {toastMessage}
                      </h5>
                    </div>
                  </div>
                )} 
                {loading && (
                  <div className="fixed top-0 left-0 w-full h-full bg-white bg-opacity-80 z-[9999] flex justify-center items-center">
                      <div className="flex flex-col items-center">
                      <div className="w-12 h-12 border-4 border-gray-300 border-t-4 border-t-[#541f8b] rounded-full animate-spin"></div>
                          <span className="mt-4 text-lg text-gray-700">Loading, please wait...</span>
                      </div>
                  </div>
                )}
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClonePricing;

